/**
 *
 * @param size - md = 24x24, lg = 48x48 pixels
 */
const ErrorIcon = ({ size = "md" }: { size: "md" | "lg" }) =>
  size === "md" ? (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" stroke="#D70000" strokeWidth="2" />
      <path
        d="m16.5 16.5-9-9m9 0-9 9"
        stroke="#D70000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="23" fill="#fff" stroke="#D70000" stroke-width="2" />
      <path
        d="M34 34 14 14m20 0L14 34"
        stroke="#D70000"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

export default ErrorIcon;
